import {
  CREATE_NEW_RECORD_FAILURE,
  CREATE_NEW_RECORD_REQUEST,
  CREATE_NEW_RECORD_SUCCESS,
  DELETE_RECORD_FAILURE,
  DELETE_RECORD_REQUEST,
  DELETE_RECORD_SUCCESS,
  DOWNLOAD_USER_TEMPLATE_REQUEST,
  GET_DATA_TABLE_FAILURE,
  GET_DATA_TABLE_REQUEST,
  GET_DATA_TABLE_SUCCESS,
  GET_EDIT_FORM_FAILURE,
  GET_EDIT_FORM_REQUEST,
  GET_EDIT_FORM_SUCCESS,
  GET_SEARCH_FILTERS_FAILURE,
  GET_SEARCH_FILTERS_REQUEST,
  GET_SEARCH_FILTERS_SUCCESS,
  GET_USERS_FAILURE,
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  GET_USER_DATA_BY_ID_FAILURE,
  GET_USER_DATA_BY_ID_REQUEST,
  GET_USER_DATA_BY_ID_SUCCESS,
  GET_VIEW_FORM_FAILURE,
  GET_VIEW_FORM_REQUEST,
  GET_VIEW_FORM_SUCCESS,
  SAVE_USER_DATA_BY_ID_FAILURE,
  SAVE_USER_DATA_BY_ID_REQUEST,
  SAVE_USER_DATA_BY_ID_SUCCESS,
  UPLOAD_USER_FAILURE,
  UPLOAD_USER_REQUEST,
  UPLOAD_USER_SUCCESS,
  USER_FILE_UPLOAD_REQUEST,
  USER_FILE_UPLOAD_SUCCESS,
  USER_FILE_UPLOAD_FAILURE,
  DOWNLOAD_USER_REPORT_FAILURE,
  DOWNLOAD_USER_REPORT_SUCCESS,
  DOWNLOAD_USER_REPORT_REQUEST,
  UPLOAD_USERROFILE_REQUEST,
  UPLOAD_USERROFILE_FAILURE,
  UPLOAD_USERROFILE_SUCCESS,
  UPLOAD_USERROFILE_LOADER,
} from "./actionTypes";

export const getUserRequest = (payload: { caller: string, api: string, size: number; page: number, params?: any, }) => ({
  type: GET_USERS_REQUEST,
  payload,
});

export const getUserSuccess = (payload: any) => ({
  type: GET_USERS_SUCCESS,
  payload,
});

export const getUserFailure = (payload: any) => ({
  type: GET_USERS_FAILURE,
  payload,
});

export const downloadUserReportRequest = (payload: any) => ({
  type: DOWNLOAD_USER_REPORT_REQUEST,
  payload
});

export const downloadUserReportSuccess = (payload: any) => ({
  type: DOWNLOAD_USER_REPORT_SUCCESS,
  payload,
});

export const downloadUserReportFailure = (payload: any) => ({
  type: DOWNLOAD_USER_REPORT_FAILURE,
  payload,
});

export const downloadUserTemplateRequest = () => ({
  type: DOWNLOAD_USER_TEMPLATE_REQUEST,
});

export const downloadUserTemplateSuccess = (payload: any) => ({
  type: GET_USERS_REQUEST,
  payload,
});

export const downloadUserTemplateFailure = (payload: any) => ({
  type: GET_USERS_REQUEST,
  payload,
});

export const uploadUserProfileRequest = (payload: any) => ({
  type: UPLOAD_USERROFILE_REQUEST,
  payload,
});

export const uploadUserrProfileRequestSuccess = (payload: any) => ({
  type: UPLOAD_USERROFILE_SUCCESS,
  payload,
});

export const uploadUserrProfileRequestFailure = (payload: any) => ({
  type: UPLOAD_USERROFILE_FAILURE,
  payload,
});

export const uploadUserrProfileLoader = (payload: any) => ({
  type: UPLOAD_USERROFILE_LOADER,
  payload,
});
export const uploadUserRequest = (payload: any) => ({
  type: UPLOAD_USER_REQUEST,
  payload,
});

export const uploadUserRequestSuccess = (payload: any) => ({
  type: UPLOAD_USER_SUCCESS,
  payload,
});

export const uploadUserRequestFailure = (payload: any) => ({
  type: UPLOAD_USER_FAILURE,
  payload,
});

export const userFileUploadRequest = (payload: any) => ({
  type: USER_FILE_UPLOAD_REQUEST,
  payload,
});

export const userFileUploadSuccess = (payload: any) => ({
  type: USER_FILE_UPLOAD_SUCCESS,
  payload,
});

export const userFileUploadFailure = (payload: any) => ({
  type: USER_FILE_UPLOAD_FAILURE,
  payload,
});

export const getDataTableRequest = (payload: { api: string }) => ({
  type: GET_DATA_TABLE_REQUEST,
  payload
});

export const getDataTableSuccess = (payload: any) => ({
  type: GET_DATA_TABLE_SUCCESS,
  payload,
});

export const getDataTableFailure = (payload: any) => ({
  type: GET_DATA_TABLE_FAILURE,
  payload,
});


export const getSearchFiltersRequest = (payload: { api: string }) => ({
  type: GET_SEARCH_FILTERS_REQUEST,
  payload
});

export const getSearchFiltersSuccess = (payload: any) => ({
  type: GET_SEARCH_FILTERS_SUCCESS,
  payload,
});

export const getSearchFiltersFailure = (payload: any) => ({
  type: GET_SEARCH_FILTERS_FAILURE,
  payload,
});

export const getEditFormRequest = (payload: { blueprintApi: string }) => ({
  type: GET_EDIT_FORM_REQUEST,
  payload,
});

export const getEditFormSuccess = (payload: any) => ({
  type: GET_EDIT_FORM_SUCCESS,
  payload,
});

export const getEditFormFailure = (payload: any) => ({
  type: GET_EDIT_FORM_FAILURE,
  payload,
});

export const getViewFormRequest = (payload: { blueprintApi: string, recordId: string }) => ({
  type: GET_VIEW_FORM_REQUEST,
  payload,
});

export const getViewFormSuccess = (payload: any) => ({
  type: GET_VIEW_FORM_SUCCESS,
  payload,
});

export const getViewFormFailure = (payload: any) => ({
  type: GET_VIEW_FORM_FAILURE,
  payload,
});


export const getUserDataByIdRequest = (userId: string) => ({
  type: GET_USER_DATA_BY_ID_REQUEST,
  userId,
});

export const getUserDataByIdSuccess = (payload: any) => ({
  type: GET_USER_DATA_BY_ID_SUCCESS,
  payload,
});

export const getUserDataByIdFailure = (payload: any) => ({
  type: GET_USER_DATA_BY_ID_FAILURE,
  payload,
});

export const saveUserDataByIdRequest = (payload: { api: string, recordId: string, data: any }) => ({
  type: SAVE_USER_DATA_BY_ID_REQUEST,
  payload,
});

export const saveUserDataByIdSuccess = (payload: any) => ({
  type: SAVE_USER_DATA_BY_ID_SUCCESS,
  payload,
});

export const saveUserDataByIdFailure = (payload: any) => ({
  type: SAVE_USER_DATA_BY_ID_FAILURE,
  payload,
});

export const createNewRecordRequest = (payload: { api: string, data: any, recordId: string }) => ({
  type: CREATE_NEW_RECORD_REQUEST,
  payload,
});

export const createNewRecordSuccess = (payload: any) => ({
  type: CREATE_NEW_RECORD_SUCCESS,
  payload,
});

export const createNewRecordFailure = (payload: any) => ({
  type: CREATE_NEW_RECORD_FAILURE,
  payload,
});

export const deleteRecordRequest = (payload: { api: string, recordId: string }) => ({
  type: DELETE_RECORD_REQUEST,
  payload,
});

export const deleteRecordSuccess = (payload: any) => ({
  type: DELETE_RECORD_SUCCESS,
  payload,
});

export const deleteRecordFailure = (payload: any) => ({
  type: DELETE_RECORD_FAILURE,
  payload,
});